import Box from "@mui/material/Box";

import Button from "@mui/material/Button";
import {
  Stack,
  Divider,
  Typography,
  Grid,
  Chip,
  Alert,
  Snackbar,
  TextField,
} from "@mui/material";

import React, { useState, useEffect } from "react";

import api from "../../services/api";
import { requestAgendarConsulta } from "../../services/cadastroService";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import {
  FieldAutocomplete,
  FieldDatePicker,
  FieldSelect,
  FieldTimePicker,
} from "../../components/Fields";
import { formatDateISO8601 } from "../../utils/formatarData";
import dayjs from "dayjs";
import ModalDialogs from "../../components/ModalDialogs";
import { useNavigate } from "react-router-dom";
import { getItemDecrypt } from "../../utils/cryptoData";

const consultTypes = [
  {
    id: 1,
    label: "Presencial",
  },
  {
    id: 2,
    label: "Teleconsulta",
  },
  {
    id: 3,
    label: "Híbrida",
  },
];

export default function NovoAgendamento() {
  const navigate = useNavigate();
  const [estabelecimentoSaude, setEstabelecimentoSaude] = useState({});
  const [usuarioAtivo, setUsuarioAtivo] = useState({});

  const [tipoConsulta, setTipoConsulta] = useState("");
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [openAgendamento, setOpenAgendamento] = useState(false);

  const [paciente, setPaciente] = useState("");
  const [pacientesList, setPacientesList] = useState([]);

  const [equipeDeSaudeInterna, setEquipeDeSaudeInterna] = useState([]);
  const [equipeDeSaudeInternaList, setEquipeDeSaudeInternaList] = useState([]);

  const [equipeDeSaudeExterna, setEquipeDeSaudeExterna] = useState([]);
  const [equipeDeSaudeExternaList, setEquipeDeSaudeExternaList] = useState([]);

  const [equipeDeSaudeTotal, setEquipeDeSaudeTotal] = useState([]);

  const [openErro, setOpenErro] = useState(false);
  const [mensagemErro, setMensagemErro] = useState("");

  let vinculo = getItemDecrypt("vinculo_ativo");
  let perfilAdministrador = vinculo.perfil.id === 1;

  useEffect(() => {
    let usuario = getItemDecrypt("usuario");
    let estabelecimento = vinculo.estabelecimento;

    setUsuarioAtivo(usuario);
    setEstabelecimentoSaude(estabelecimento);

    getData(estabelecimento.id);
    getParticipantesInternos(estabelecimento.id, usuario.co_id);
    getParticipantesExternos(estabelecimento.id);
  }, []);

  useEffect(() => {
    setEquipeDeSaudeTotal([...equipeDeSaudeExterna, ...equipeDeSaudeInterna]);
  }, [equipeDeSaudeExterna, equipeDeSaudeInterna]);

  async function limparCampos() {
    setDataAgendamento("");
    setHoraAgendamento("");
    setTipoConsulta("");
    setPaciente("");
    setEquipeDeSaudeInterna([]);
    setEquipeDeSaudeExterna([]);
  }

  async function getData(id_estabelecimento) {
    try {
      const { data } = await api.post("/pacientes-vivos/", {
        id_estabelecimento,
        id_vinculo: vinculo.id,
      });
      setPacientesList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getParticipantesInternos(id_estabelecimento, id_usuario) {
    try {
      const { data } = await api.post(`/profissionais-internos/`, {
        id_estabelecimento: id_estabelecimento,
        id_usuario: id_usuario,
      });

      setEquipeDeSaudeInternaList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getParticipantesExternos(id_estabelecimento) {
    try {
      const { data } = await api.get(
        `/profissionais-externos/${id_estabelecimento}`
      );
      setEquipeDeSaudeExternaList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const profissionalJaInserido = (novoProfissional) => {
    return (
      equipeDeSaudeExterna.some((objeto) => {
        return objeto.nome === novoProfissional.nome;
      }) ||
      equipeDeSaudeInterna.some((objeto) => {
        return objeto.nome === novoProfissional.nome;
      })
    );
  };

  const handleEquipeSaudeExterna = (newValue) => {
    if (typeof newValue[0] === "object" && newValue !== null) {
      const ultimoAdicionado = newValue[newValue.length - 1];

      if (profissionalJaInserido(ultimoAdicionado)) {
        setOpenErro(true);
        setMensagemErro("O profissional de saúde selecionado já foi inserido.");
      } else {
        setEquipeDeSaudeExterna(newValue);
      }
    }
  };

  const handleEquipeSaudeInterna = (newValue) => {
    if (typeof newValue[0] === "object" && newValue !== null) {
      const ultimoAdicionado = newValue[newValue.length - 1];
      if (profissionalJaInserido(ultimoAdicionado)) {
        setOpenErro(true);
        setMensagemErro("O profissional de saúde selecionado já foi inserido.");
      } else {
        setEquipeDeSaudeInterna(newValue);
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (paciente === "") {
      setOpenErro(true);
      setMensagemErro("Nome do paciente é um campo obrigatório.");
      return;
    }

    if (equipeDeSaudeInterna.length === 0 && perfilAdministrador) {
      setOpenErro(true);
      setMensagemErro("Equipe de saúde interna é um campo obrigatório.");
      return;
    }

    const data = {
      idVinculo: vinculo.id,
      idPaciente: paciente.id,
      idEstabelecimento: estabelecimentoSaude.id,
      dataAgendamento,
      horaAgendamento: dayjs(horaAgendamento).format("HH:mm"),
      tipoConsulta,
      equipeDeSaudeTotal,
    };

    const response = await requestAgendarConsulta(data);

    if (response.hasOwnProperty("error")) {
      setMensagemErro(response.error);
      setOpenErro(true);
      return;
    }

    limparCampos();
    setOpenAgendamento(true);
  };

  function redirectAgendamentos() {
    navigate("/agendamentos");
  }

  const styles = {
    title: {
      fontWeight: "600",
      fontSize: "26px",
      lineHeight: "35px",
      color: "#063F5E",
      fontFamily: "Nunito, sans-serif ",
    },
    formTitle: {
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "22px",
      color: "#063F5E",
    },
    subtitle: {
      fontWeight: "500",
      fontSize: "22px",
      lineHeight: "30px",
      color: "#1E729F",
      fontFamily: "Nunito, sans-serif ",
    },
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      textAlign: "center",
      zoom: "70%",
    },
  };

  const selectedValuesInternaList = React.useMemo(() => {
    return equipeDeSaudeInternaList.filter((value) =>
      equipeDeSaudeInterna.some((item) => item.co_id === value.co_id)
    );
  }, [equipeDeSaudeInternaList, equipeDeSaudeInterna]);

  const selectedValuesExternaList = React.useMemo(() => {
    return equipeDeSaudeExternaList.filter((value) =>
      equipeDeSaudeExterna.some((item) => item.co_id === value.co_id)
    );
  }, [equipeDeSaudeExternaList, equipeDeSaudeExterna]);

  return (
    <Box>
      <Box>
        <ButtonGoBack />

        <Box>
          <Box style={styles.title}>Novo agendamento</Box>
        </Box>

        <Box
          sx={{
            boxShadow: "0px 1px 8px 0px #00000026",
            boxSizing: "border-box !important",
            padding: "30px 24px",
            margin: "32px 0px",
            borderRadius: "8px",
            width: "100%",
          }}
        >
          <Typography style={styles.subtitle} mb={2}>
            Dados novo agendamento
          </Typography>
          <Alert
            color="primary"
            icon={false}
            sx={{
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "19px",
              color: "#1E729F",
              fontFamily: "Nunito, sans-serif ",
            }}
          >
            Os dados de profissional responsável e local de atendimento são
            preenchidos automaticamente de acordo com seu perfil.
          </Alert>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                pr: "20%",
                mt: 3,
                mb: 2,
              }}
            >
              <Stack spacing={1} sx={{ mb: 2 }}>
                <Typography style={styles.formTitle}>
                  Local de atendimento
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Nunito",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "22px",
                    color: "#737373",
                    textTransform: "capitalize",
                  }}
                >
                  {estabelecimentoSaude && estabelecimentoSaude.nome}
                </Typography>
              </Stack>

              <Stack spacing={1} sx={{ mb: 2 }}>
                <Typography style={styles.formTitle}>
                  Profissional responsável
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Nunito",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "22px",
                    color: "#737373",
                  }}
                >
                  {usuarioAtivo && usuarioAtivo.no_nome_usuario}
                </Typography>
              </Stack>
            </Stack>
            <Divider spacing={2} sx={{ mb: 2 }} />
            <Grid
              container
              gap={"24px 16px"}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                boxSizing: "border-box !important",
                textAlign: "left",
                mb: 2,
              }}
              width="100%"
            >
              <Grid item>
                <FieldSelect
                  label="Tipo da consulta"
                  value={tipoConsulta}
                  setValue={(value) => setTipoConsulta(value)}
                  items={consultTypes}
                  isEditField={true}
                  required
                />
              </Grid>
              <Grid item>
                <FieldDatePicker
                  label="Data"
                  value={dataAgendamento}
                  setValue={(value) =>
                    setDataAgendamento(formatDateISO8601(value))
                  }
                  defaultValue={null}
                  required
                  isEditField={true}
                />
              </Grid>
              <Grid item>
                <FieldTimePicker
                  label="Hora"
                  value={horaAgendamento}
                  setValue={(value) => setHoraAgendamento(value)}
                  isEditField={true}
                  required
                />
              </Grid>
            </Grid>
            <Stack gap={2}>
              <FieldAutocomplete
                label="Nome do paciente"
                isEditField={true}
                noOptionsText={"Nenhum resultado encontrado"}
                getOptionLabel={(option) => {
                  if (option.nome) {
                    return `${option.cpf} - ${option.nome}`;
                  } else {
                    return "Pesquisar paciente";
                  }
                }}
                options={pacientesList}
                value={paciente}
                setValue={(e, newValue) => setPaciente(newValue)}
                disablePortal={true}
                required
              />
              <Stack>
                <FieldAutocomplete
                  label="Equipe de saúde interna"
                  multiple
                  isEditField={true}
                  noOptionsText={"Nenhum resultado encontrado"}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.perfil} - ${option.conselho} - ${option.numero_conselho}` ||
                    ""
                  }
                  options={equipeDeSaudeInternaList}
                  value={selectedValuesInternaList}
                  setValue={(e, newValue) =>
                    handleEquipeSaudeInterna(newValue.map((item) => item))
                  }
                  renderTags={() => null}
                  required={perfilAdministrador}
                  renderInput={(params) => (
                    <TextField
                      variant="outlined"
                      placeholder={"Selecione"}
                      {...params}
                    />
                  )}
                />
                <Stack direction="row" flexWrap="wrap" mt={1}>
                  {equipeDeSaudeInterna.map((v, index) => (
                    <Chip
                      sx={{
                        background: "#D3E3EB",
                        color: "#1E729F",
                        margin: "4px",
                      }}
                      key={v.co_id}
                      label={`${v.nome} - ${v.perfil} - ${v.conselho} - ${v.numero_conselho}`}
                      onDelete={(valor) => {
                        setEquipeDeSaudeInterna((prevState) =>
                          equipeDeSaudeInterna.filter(
                            (data) => data.co_id !== v.co_id
                          )
                        );
                      }}
                    />
                  ))}
                </Stack>
              </Stack>
              <Stack>
                <FieldAutocomplete
                  label="Equipe de saúde externa"
                  multiple
                  isEditField={true}
                  noOptionsText={"Nenhum resultado encontrado"}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.perfil} - ${option.conselho} - ${option.numero_conselho}` ||
                    ""
                  }
                  freeSolo
                  options={equipeDeSaudeExternaList}
                  value={selectedValuesExternaList}
                  setValue={(e, newValue) =>
                    handleEquipeSaudeExterna(newValue.map((item) => item))
                  }
                  renderTags={() => null}
                />
                <Stack direction="row" flexWrap="wrap" mt={1}>
                  {equipeDeSaudeExterna.map((v, index) => (
                    <Chip
                      sx={{
                        background: "#D3E3EB",
                        color: "#1E729F",
                        margin: "4px",
                      }}
                      key={v.co_id}
                      label={`${v.nome} - ${v.perfil} - ${v.conselho} - ${v.numero_conselho}`}
                      onDelete={(valor) => {
                        setEquipeDeSaudeExterna((prevState) =>
                          equipeDeSaudeExterna.filter(
                            (data) => data.co_id !== v.co_id
                          )
                        );
                      }}
                    />
                  ))}
                </Stack>
              </Stack>
            </Stack>

            <Stack
              direction="row"
              sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
            >
              <Button></Button>
              <Button
                variant="contained"
                type="submit"
                onSubmit={() => setOpenAgendamento(true)}
              >
                Criar
              </Button>
            </Stack>
            <ModalDialogs
              open={openAgendamento}
              onClose={() => setOpenAgendamento(false)}
              title="Sucesso"
              modalType="success"
              onActionPrimary={() => redirectAgendamentos()}
              primaryButtonText="Ir para agendamentos"
              body={
                <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
                  Consulta agendada com sucesso!
                </Box>
              }
            />

            {openErro && (
              <Snackbar
                open
                onClose={() => setOpenErro(false)}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                message={mensagemErro}
              >
                <Alert severity="error" onClose={() => setOpenErro(false)}>
                  {mensagemErro}
                </Alert>
              </Snackbar>
            )}
          </form>
        </Box>
      </Box>
    </Box>
  );
}
